'use client';

import {
  useOrderParam,
  type AccountPage,
} from '@eliadmin/core/src/components/nt/account/shell/account-pages';
import { Breadcrumbs, type BreadcrumbItem } from '@eliadmin/core/src/components/nt/ui/breadcrumbs';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

/**
 * Figma breadcrumbs of the account pages: „Domov › Moje konto › Môj profil“ (205:11185); the order
 * detail adds its number after a linked „Moje objednávky“ (208:12026), the core return form
 * „Vrátenie tovaru“. Reads `?objednavka=` – render inside `<Suspense>`.
 */
export function AccountBreadcrumbs({
  page,
  isReturn,
}: {
  page: AccountPage | null;
  isReturn: boolean;
}) {
  const { t } = useTranslations();
  const order = useOrderParam();
  const sub = isReturn ? t('text372') : page?.key === 'orders' && order ? order : null;

  const items: BreadcrumbItem[] = [
    { label: t('text160'), href: '/' },
    { label: t('text1734'), href: ROUTES.PROFILE() },
    ...(page ? [{ label: t(page.label), href: sub ? page.href() : undefined }] : []),
    ...(sub ? [{ label: sub }] : []),
  ];

  // The landmark name („Omrvinky - názov“) is a category text – not loaded for the account (reported).
  return <Breadcrumbs items={items} />;
}
